export class PhoneNumberDto {
  id: string;
  notes: string;
  number: string;
  type = 'WORK';

  constructor(d?: PhoneNumberDto) {
    if (!d) {
      return;
    }
    this.id = d.id;
    this.notes = d.notes;
    this.number = d.number;
    this.type = d.type;
  }
}
